import $ from 'jquery/src/jquery';
import SiteHeader from "../modules/site-header";

export default () => {
    const nodeSelectors = {
        container: '[js-site-nav-mobile="container"]',
        opener: '[js-site-nav-mobile="opener"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initNav()
    }

    function initNav() {
        $(document).keyup(function(e) {
            if (e.key === "Escape") {
                close();
            }
        });

        $(nodeSelectors.opener).on('click', function () {
            if( $(nodeSelectors.container).is(':visible') ) {
                close()
            } else {
                open()
            }
        })

        $(nodeSelectors.container + ' .menu-item-has-children').on('click', function (e) {
            e.stopPropagation()

            let clickedElement = $(e.target);

            if (clickedElement.is('a')) {
                return
            }

            $(this).toggleClass('submenu-is-active')

            let subMenu = $(this).find(' > .sub-menu')

            if( !subMenu.is(':visible') ) {
                e.preventDefault()
            } else {

            }

            subMenu.slideToggle()
        })
    }

    function open() {
        $('body, html').addClass('gl-mobile-nav-active-no-scroll')
        $(nodeSelectors.opener).addClass('active');
        $(nodeSelectors.container).fadeIn(250);
        $(SiteHeader().nodeSelectors.container).addClass('nav-is-active')

        if( $(window).width() < 768 ) {
            $([document.documentElement, document.body]).animate({
                scrollTop: 0
            }, 80);
        }
    }

    function close() {
        $('body, html').removeClass('gl-mobile-nav-active-no-scroll')
        $(nodeSelectors.container).fadeOut(200);
        $(nodeSelectors.opener).removeClass('active');
        $(SiteHeader().nodeSelectors.container).removeClass('nav-is-active')
    }

    return Object.freeze({
        init,
        close,
        open,
        nodeSelectors
    })
}